import React from "react";

const ActiveSessionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5957 18.3711H21.375C22.0781 18.3711 22.6299 18.1709 23.0303 17.7705C23.4306 17.3701 23.6308 16.8184 23.6308 16.1153V4.40625C23.6308 3.70313 23.4306 3.153 23.0303 2.75586C22.6299 2.35872 22.0781 2.16016 21.375 2.16016H2.5957C1.89909 2.16016 1.35058 2.35872 0.950195 2.75586C0.549805 3.153 0.349609 3.70313 0.349609 4.40625V16.1153C0.349609 16.8184 0.549805 17.3701 0.950195 17.7705C1.35058 18.1709 1.89909 18.3711 2.5957 18.3711ZM2.3418 14.0645C2.06185 14.0645 1.92188 13.9245 1.92188 13.6446V4.43554C1.92188 4.21419 1.98536 4.04167 2.11231 3.91797C2.23926 3.79427 2.41015 3.73242 2.625 3.73242H21.3555C21.5703 3.73242 21.7412 3.79427 21.8682 3.91797C21.9951 4.04167 22.0586 4.21419 22.0586 4.43554V13.6446C22.0586 13.9245 21.9154 14.0645 21.6289 14.0645H2.3418ZM8.9043 20.6954H15.0762V18.2442H8.9043V20.6954ZM8.8457 21.8379H15.1348C15.3496 21.8379 15.5335 21.7614 15.6865 21.6084C15.8395 21.4554 15.916 21.2682 15.916 21.0469C15.916 20.8255 15.8395 20.6384 15.6865 20.4854C15.5335 20.3324 15.3496 20.2559 15.1348 20.2559H8.8457C8.63086 20.2559 8.44531 20.3324 8.28906 20.4854C8.13281 20.6384 8.05469 20.8255 8.05469 21.0469C8.05469 21.2682 8.13281 21.4554 8.28906 21.6084C8.44531 21.7614 8.63086 21.8379 8.8457 21.8379Z"
        fill="#3D68FF"
      />
    </svg>
  );
};

export default ActiveSessionIcon;
